module.exports = __webpack_public_path__ + "img/home_recom_original.7e836d90.png";